import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { Form, Button, FieldRadioButton, FieldTextInput } from '../../components';
import { YES_OPTION_KEY, NO_OPTION_KEY } from '../../marketplace-custom-config';

import css from './EditListingBoardExperienceForm.module.css';

const EditListingBoardExperienceFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        saveActionMsg,
        updated,
        pristine,
        updateInProgress,
        fetchErrors,
        values,
      } = formRenderProps;

      const { updateListingError, createListingDraftError, showListingsError } = fetchErrors || {};

      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingBoardExperienceForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageCreateListingDraft = createListingDraftError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingBoardExperienceForm.createListingDraftError" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingBoardExperienceForm.showListingFailed" />
        </p>
      ) : null;

      const hasExperience = values.hasExperience === YES_OPTION_KEY;
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress;

      const classes = classNames(css.root, className);

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessageCreateListingDraft}
          {errorMessageUpdateListing}
          {errorMessageShowListing}

          <p className={css.description}>
            <FormattedMessage id="EditListingBoardExperienceForm.description" />
          </p>

          <div className={css.radioGroup}>
            <FieldRadioButton
              id="boardExperience-yes"
              name="hasExperience"
              label={<FormattedMessage id="EditListingBoardExperienceForm.yes" />}
              value={YES_OPTION_KEY}
            />
            <FieldRadioButton
              id="boardExperience-no"
              name="hasExperience"
              label={<FormattedMessage id="EditListingBoardExperienceForm.no" />}
              value={NO_OPTION_KEY}
            />
          </div>

          {hasExperience && (
            <FieldTextInput
              id="boardExperienceDetails"
              name="details"
              className={css.detailsInput}
              type="textarea"
              label={<FormattedMessage id="EditListingBoardExperienceForm.detailsLabel" />}
              placeholder=""
            />
          )}

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingBoardExperienceFormComponent.defaultProps = {
  fetchErrors: null,
};

EditListingBoardExperienceFormComponent.propTypes = {
  disabled: bool.isRequired,
  ready: bool.isRequired,
  saveActionMsg: string,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: object,
  intl: intlShape.isRequired,
};

const EditListingBoardExperienceForm = injectIntl(EditListingBoardExperienceFormComponent);

export default EditListingBoardExperienceForm;
